import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';

import { shadowCommon, shadowLeft, shadowRight, shadowWidth } from './styles';

interface CarouselNavigationShadowsProps {
  showLeftShadow?: boolean;
  showRightShadow?: boolean;
}

function CarouselNavigationShadows({
  showLeftShadow,
  showRightShadow,
}: CarouselNavigationShadowsProps) {
  const { isMobile } = useScreen();

  return (
    <>
      {showLeftShadow ? (
        <Box className={cn(shadowCommon, shadowLeft, shadowWidth(isMobile))} />
      ) : null}
      {showRightShadow ? (
        <Box className={cn(shadowCommon, shadowRight, shadowWidth(isMobile))} />
      ) : null}
    </>
  );
}

export default React.memo(CarouselNavigationShadows);
